export default __webpack_public_path__ + "caa2477a80e3906f1d829af1fdbbb936.png";